/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Grid, Button, Stack } from "@mui/material";
import { NavigateNext } from "@mui/icons-material";
import { useFormik } from "formik";
import {
  CustomFormLabel,
  CustomTextField,
} from "../../../components/formsComponents";
import { IMarketCampaignBasicInfo } from "../../../redux/marketCampaign/marketCampaign.types";
import {
  upsertDraftStepAsync,
  upsertMarketCampaignBasicInfoAsync,
} from "../../../redux/marketCampaign/marketCampaignActions";
import { useBillingCompanyContext } from "../../../providers";
import { useMarketCampaignContext } from "../MarketCampaign.context-state";
import { useDispatchAction } from "../../../redux/store.hooks";

export const Step1MarketCampaignDetails = React.memo(() => {
  const dispatch = useDispatchAction();
  const companyOutlet = useBillingCompanyContext();
  const {
    state,
    marketCampaign,
    isEditable,
    isAutoGenerating,
draftSteps,
    onStateChange,
  } = useMarketCampaignContext();
  const [loading, setLoading] = React.useState(false);

  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    setValues,
    touched,
    handleBlur,
  } = useFormik({
    initialValues: marketCampaign,
    validate: (values: IMarketCampaignBasicInfo) => {
      const errors: any = {};
      if (!values.campaign_name) {
        errors.campaign_name = "Campaign name is required";
      }
      return errors;
    },
    onSubmit: async (values: IMarketCampaignBasicInfo) => {
      setLoading(true);
      const marketCampaignPayload = {
        ...values,
        sending_type: "QUICK",
        company_outlet_uuid: companyOutlet.comapny.company_outlet_uuid,
        status: "DRAFT",
      };

      dispatch(
        upsertMarketCampaignBasicInfoAsync(
          marketCampaignPayload,
          (responseData) => {
            const draftStatePayload = {
              draft_step_uuid: responseData.market_campaign_uuid || "",
              total_steps: 4,
              current_step: 1,
              draft_step_data: { step_one_data: responseData },
              status: "ACTIVE" as "ACTIVE",
            };
            dispatch(
              upsertDraftStepAsync(
                draftStatePayload,
                (draftState) => {
                  setLoading(false);
                  onStateChange({
                    ...state,
                    marketCampaign: responseData,
                    draftSteps: draftState,
                    completionSteps: {
                      ...state.completionSteps,
                      step1: true,
                    },
                    activeStep: 1,
                    maxAllowedSteps: 1,
                  });
                },
                () => {
                  setLoading(false);
                }
              )
            );
          },
          () => {
            setLoading(false);
          }
        )
      );
    },
  });

  React.useEffect(() => {
    if (marketCampaign) {
      setValues(marketCampaign);
    }
  }, [marketCampaign]);

  const isFormDisabled = !isEditable || isAutoGenerating || draftSteps?.draft_step_data?.step_one_data?.lock === 1

  return (
    <Grid
      container
      spacing={1}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
      }}
    >
      <Grid item xs={12} md={4}></Grid>
      <Grid item xs={12} md={9.5}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={6}>
              {/* <CustomFormLabel>Campaign Name</CustomFormLabel> */}
              <CustomTextField
                label="Campaign Name"
                disabled={isFormDisabled}
                name="campaign_name"
                value={values.campaign_name}
                fullWidth
                placeholder="Enter Campaign Name"
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.campaign_name && Boolean(errors.campaign_name)}
                helperText={touched.campaign_name && errors.campaign_name}
              />
            </Grid>

            <Grid item xs={12}>
              {/* <CustomFormLabel>Description</CustomFormLabel> */}
              <CustomTextField
                disabled={isFormDisabled}
                name="campaign_description"
                label="Description"
                value={values.campaign_description}
                multiline
                placeholder="Enter a brief description of your campaign"
                rows={3}
                fullWidth
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </Grid>

            <Grid item xs={12} md={12}>
              <Stack
                direction={"row"}
                mt={3}
                sx={{ display: "flex", justifyContent: "end" }}
                gap={2}
              >
                {isEditable ? (
                  <Button
                    variant="contained"
                    endIcon={<NavigateNext />}
                    type="submit"
                    disabled={loading || isAutoGenerating}
                  >
                    Save & Next
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    endIcon={<NavigateNext />}
                    onClick={() =>
                      onStateChange({
                        ...state,
                        marketCampaign: values,
                        completionSteps: {
                          ...state.completionSteps,
                          step1: true,
                        },
                        activeStep: 1,
                        maxAllowedSteps: 1,
                      })
                    }
                  >
                    Next
                  </Button>
                )}
              </Stack>
            </Grid>
          </Grid>
        </form>
      </Grid>
    </Grid>
  );
});
